module.exports = __webpack_public_path__ + "static/img/zljc.b703dfa0.png";